import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import { PROJECT_CATEGORY_API } from "./apiRoutes";

interface mutateProps {
  tenantId: string;
  data: FieldValues;
}

const mutateAddProjectCategory = async ({ tenantId, data }: mutateProps) => {
  return await axiosAuth.post(`${PROJECT_CATEGORY_API(tenantId)}`, data);
};

const useAddProjectCategoryMutation = (
  queryParams?: UseMutationOptions<any, Error, mutateProps, unknown>
) =>
  useMutation({
    mutationFn: mutateAddProjectCategory,
    ...queryParams,
  });

export default useAddProjectCategoryMutation;
